import {Suspense} from "react";
import ReactDOM from "react-dom/client";
import App from './App';
import {store} from './store/store';
import {Provider} from "react-redux";
import {getAccessToken} from "./services/api-user-service";
import {AuthUser} from "./store/action-creators/userActions";

const token = getAccessToken();
if (token) {
    AuthUser(token, "Loaded from local storrage.", store.dispatch);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <Suspense fallback={<div>Loading...</div>}>
            <App />
        </Suspense>
    </Provider>
);